import type { IOrdersLineItemsEdges } from "../queries/customer-gql";

// 반환되는 각각의 라인아이템에 originalQuantity 값만 추가로 반환하는 방식
export const fetchOrder = async ({
  storeName,
  domain = "",
  customerId,
  orderId,
}: {
  storeName: string;
  domain?: "kr" | "jp" | "intl" | "";
  customerId: string;
  orderId: string;
}): Promise<IFetchOrder | undefined> => {
  const lambdaUrl = "https://k4rtgzhpqwjfuk7yb5rbdmu4fy0qrhvt.lambda-url.ap-northeast-2.on.aws/"; // common_get_order_v2
  try {
    const response = await fetch(lambdaUrl, {
      method: "POST",
      body: JSON.stringify({ storeName, domain, customerId, orderId }),
    }).then((res) => res);

    if (response.status === 200) {
      return (await response.json()) as IFetchOrder;
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};

export interface IFetchOrder {
  returnStatus: string;
  displayFinancialStatus: string;
  displayFulfillmentStatus: string;
  lineItems: ILineItem[];
  returnLineItems: IReturnLineItem[];
  refundLineItems: ILineItem[];
  totalReturnShippingFee: number;
  totalRefundedSet: IShopMoney;
  totalPriceSet: IShopMoney;
  totalDiscountsSet: IShopMoney;
  originalTotalPriceSet: IShopMoney;
  netPaymentSet: IShopMoney;
}

export interface ILineItemBase {
  id: string;
  title: string;
  image?: {
    url: string;
    width: number;
    height: number;
  } | null;
  variantTitle: string;
  variant?: IVariant | null;
  originalTotalPrice: IShopMoney;
  discountedTotalPrice?: IShopMoney;
  quantity: number;
  originalQuantity: number;
  discountAllocations: IDiscountAllocation[];
}

type TLineItemNode = IOrdersLineItemsEdges["node"];

export interface ILineItem extends TLineItemNode {
  id: string;
  title: string;
  image?: {
    url: string;
    width: number;
    height: number;
  } | null;
  variantTitle: string;
  refundableQuantity?: number;
  originalQuantity: number;
  totalDiscountSet: IShopMoney;
  // variant?: IVariant | null;
}

export interface IReturnLineItem extends ILineItemBase {
  customerNote: string;
  returnReason: string;
}

export interface IVariant {
  title: string;
  compareAtPrice: {
    amount: string;
  };
  price: {
    amount: string;
  };
  selectedOptions: { name: string; value: string }[];
  image: {
    url: string;
    width: number;
    height: number;
  };
  product: {
    handle: string;
    vendor: string;
    tags: string[];
    title: string;
  };
}

interface IShopMoney {
  amount: string;
}

export interface IDiscountAllocation {
  allocatedAmount: IShopMoney;
}
